import { render } from "./CookiePolicy.vue?vue&type=template&id=2a248163&scoped=true"
import script from "./CookiePolicy.vue?vue&type=script&lang=js"
export * from "./CookiePolicy.vue?vue&type=script&lang=js"

import "./CookiePolicy.vue?vue&type=style&index=0&id=2a248163&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a248163"]])

export default __exports__